module.exports = __webpack_public_path__ + "static/media/pg_banner.6d22472a.png";